<div class="treg-page">

  <header class="treg-head">
    <img class="treg-logo" src="assets/img/icon.png" alt="SHIVAM">
    <div class="treg-headings">
      <h1 class="treg-title">Temple Registration</h1>
      <p class="treg-sub">This installation is not registered yet. Register the temple to create the first
        administrator and set up the accounts.</p>
    </div>
    @if (form && !successCode) {
      <!-- Default language: top right, no label (owner directive). -->
      <div class="treg-lang" title="Default language">
        <i class="fa fa-globe" aria-hidden="true"></i>
        <select class="form-control form-control-sm" aria-label="Default language"
          [value]="form.value.language" (change)="onLanguagePick($any($event.target).value)">
          @for (lang of languages; track lang.id) {
            <option [value]="lang.id">{{ lang.label }}</option>
          }
        </select>
      </div>
    }
  </header>

  @if (checking) {
    <p class="treg-note">Checking this installation…</p>
  }

  @if (!cloudConfigured && !successCode) {
    <div class="treg-warn">Registration needs an internet connection and will fail until it is set.<br>
      A 6-digit temporary password is generated and sent to the WhatsApp number below. Change it after the
      first sign-in.
    </div>
  }

  @if (successCode) {
    <div class="treg-success">
      <h2>Registration complete</h2>
      <p>Your temple code is <strong>{{ successCode }}</strong>.</p>
      <p>Check your WhatsApp for the temporary password and log in with this username:
        <strong>{{ successUserName }}</strong>.</p>
      <button type="button" class="treg-btn" (click)="goToLogin()">Go to login</button>
    </div>
  } @else if (form) {
    <form class="treg-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <br>
      <h2 class="treg-section">Temple</h2>
      <div class="treg-grid">
        <label class="treg-field treg-wide">
          <span>Temple name *</span>
          <input type="text" class="form-control form-control-sm" formControlName="name" autocomplete="off"
            (input)="onTitleCaseInput($event, 'name')">
          @if (form.controls['name'].touched && form.controls['name'].invalid) {
            <em class="treg-err">Required</em>
          }
        </label>
        <label class="treg-field">
          <span>Short name</span>
          <input type="text" class="form-control form-control-sm" formControlName="nameShort" autocomplete="off">
        </label>
        <div class="treg-field">
          <span>Main deity *</span>
          <app-lookup class="form-control form-control-sm" formControlName="mainDeity" [freeText]="true"
            [suggestions]="false" [manglish]="isMalayalam" [manglishDefault]="manglishDefault"
            inputId="tregDeity"></app-lookup>
          @if (form.controls['mainDeity'].touched && form.controls['mainDeity'].invalid) {
            <em class="treg-err">Required</em>
          }
        </div>

        <div class="treg-field">
          <span>WhatsApp Phone *</span>
          <app-mobile-input class="form-control form-control-sm" formControlName="mobile" [required]="true"
            inputId="tregWhatsApp" placeholder="WhatsApp number"></app-mobile-input>
          @if (form.controls['mobile'].touched && form.controls['mobile'].invalid) {
            <em class="treg-err">Required — the temporary password is sent here</em>
          }
        </div>
        <label class="treg-field treg-wide">
          <span>Address</span>
          <input type="text" class="form-control form-control-sm" formControlName="address1" autocomplete="off"
            (input)="onTitleCaseInput($event, 'address1')">
        </label>
        <label class="treg-field">
          <span>City</span>
          <input type="text" class="form-control form-control-sm" formControlName="city" autocomplete="off"
            (input)="onTitleCaseInput($event, 'city')">
        </label>

        <label class="treg-field">
          <span>District</span>
          <input type="text" class="form-control form-control-sm" formControlName="district" autocomplete="off"
            (input)="onTitleCaseInput($event, 'district')">
        </label>
        <label class="treg-field">
          <span>State</span>
          <input type="text" class="form-control form-control-sm" formControlName="state" autocomplete="off"
            (input)="onTitleCaseInput($event, 'state')">
        </label>
        <label class="treg-field">
          <span>PIN code</span>
          <input type="text" class="form-control form-control-sm" formControlName="pincode" autocomplete="off"
            inputmode="numeric" maxlength="10" (input)="onDigitsInput($event, 'pincode')">
        </label>
        <label class="treg-field">
          <span>Email</span>
          <input type="email" class="form-control form-control-sm" formControlName="email" autocomplete="off">
        </label>
      </div>
      <h2 class="treg-section">Settings</h2>
      <div class="treg-grid">
        <label class="treg-field">
          <span>Administrator name</span>
          <input type="text" class="form-control form-control-sm" formControlName="adminFirstName"
            autocomplete="off" (input)="onFullNameInput($event)">
        </label>
        <label class="treg-field">
          <span>User name *</span>
          <input type="text" class="form-control form-control-sm" formControlName="adminUserName"
            autocomplete="off" (input)="onUserNameInput($event)">
          @if (form.controls['adminUserName'].touched && form.controls['adminUserName'].invalid) {
            <em class="treg-err">Required</em>
          }
        </label>
    
        <label class="treg-field">
          <span>Currency</span>
          <select class="form-control form-control-sm" formControlName="currency">
            @for (currency of currencies; track currency.code) {
              <option [value]="currency.symbol">
                {{ currency.flag }} {{ currency.country }} — {{ currency.code }} ({{ currency.symbol }})
              </option>
            }
          </select>
        </label>
        <label class="treg-field">
          <span>Date format <em class="treg-sample">{{ dateFormatSample }}</em></span>
          <select class="form-control form-control-sm" formControlName="dateFormat">
            @for (format of dateFormats; track format.pattern) {
              <option [value]="format.pattern">{{ format.sample }}</option>
            }
          </select>
        </label>
        <label class="treg-field">
          <span>Pooja rows per invoice</span>
          <input type="number" min="1" class="form-control form-control-sm" formControlName="poojaRowLength">
        </label>
        <div class="treg-field">
          <span>Financial year starts *</span>
          <app-date-picker class="form-control form-control-sm" formControlName="financialYearStart"
            valueFormat="YYYY-MM-DD"></app-date-picker>
        </div>
        <label class="treg-check">
          <input type="checkbox" formControlName="stockAndInventory">
          <span>Stock &amp; inventory</span>
        </label>
        <label class="treg-check">
          <input type="checkbox" formControlName="showInReports">
          <span>Show temple details in reports</span>
        </label>
      </div>

      @if (errorMessage) {
        <div class="treg-error">
          {{ errorMessage }}
          @if (isAlreadyRegistered) {
            <div style="margin-top: 10px;">
              <button type="button" class="treg-btn" (click)="goToLogin()">Go to login</button>
            </div>
          }
        </div>
      }

      <!-- Outside the cards, centred under the last one (owner directive). -->
      <div class="treg-submit">
        <button type="submit" class="treg-btn treg-btn-hero" [disabled]="saving">
          <i class="fa" [class.fa-check-circle]="!saving" [class.fa-spinner]="saving" [class.fa-spin]="saving"
            aria-hidden="true"></i>
          <span>{{ saving ? 'Registering…' : 'Register Temple' }}</span>
        </button>
      </div>
    </form>
  }
</div>
